enum ExpensesTypes {
  Item = "Item",
  Time = "Time",
  Travel = "Travel",
  Shop = "Shop",
  LaborOT = "LaborOT",
  Labor = "Labor",
  MiscItem = "MiscItem",
  Mileage = "Mileage",
}

export default ExpensesTypes;
